import { api, FormatResponse } from '../index';
const BASE_ENDPOINT ='/api/v1/workflows/create-webhook-url';

export const createSalesforceWebhookUrl = async (workflowId) => {
        const webhookUrlRes = await api.patch(`${BASE_ENDPOINT}/${workflowId}`);
        return new FormatResponse(webhookUrlRes);
};